import { bodyToastQueue } from '@/components/ui/molecules/GlobalToastRegions';
import { useCustomToastQueue } from './useCustomToastQueue.hook';

export const useBodyToastQueue = () => {
    const state = useCustomToastQueue(bodyToastQueue);
    return state;
};
